/**
 * Interprets the response from api/SubForm/SaveForm.
 *
 * The server returns a JSON object on both success and failure, so the body
 * alone is always truthy. Success requires BOTH an ok HTTP status and an
 * explicit `success: true` in the body.
 */
export interface SaveFormResult {
    success: boolean;
    errors: string[];
}

export const GENERIC_SAVE_ERROR =
    'Your registration could not be saved. Please review the form and try again. ' +
    'If the problem continues, contact procurement@core-states.com.';

export function parseSaveFormResponse(ok: boolean, body: unknown): SaveFormResult {
    const obj = (body !== null && typeof body === 'object') ? (body as Record<string, unknown>) : null;

    if (ok && obj && obj.success === true) {
        return { success: true, errors: [] };
    }

    const errors: string[] = [];
    if (obj) {
        if (Array.isArray(obj.errors)) {
            errors.push(...obj.errors.filter((e): e is string => typeof e === 'string' && e.length > 0));
        }
        if (typeof obj.message === 'string' && obj.message.length > 0) {
            errors.push(obj.message);
        }
        // Only populated by the server in Development; carries the underlying exception text.
        if (typeof obj.detail === 'string' && obj.detail.length > 0) {
            errors.push(`Detail: ${obj.detail}`);
        }
    }
    if (errors.length === 0) {
        errors.push(GENERIC_SAVE_ERROR);
    }
    return { success: false, errors };
}
